import * as jQuery from 'jquery';
window.$ = jQuery;

export const shmMap = {
    config: {
        'mapBig': false,
        'mapToggle': '.js-search-map-toggle',
        'mapLat': $('.search-map--inner').data('maplat'),
        'mapLon': $('.search-map--inner').data('maplon'),
    },
    bindEvents: function() {
        shmMap.bindEventsItem();
        window.set_search_marker = shmMap.set_search_marker;
    },
    bindEventsItem: function() {
        let mapId;
        $('.js-set-map-center').on('click', function() {
            const mapIdOld = mapId;

            shmMap.set_map_center($(this).data('lat'), $(this).data('lon'));
            shmMap.set_map_zoom(11);

            mapId = $(this).data('map-id');
            shmMap.set_map_focus(mapId, mapIdOld);
        });
    },
    init: function() {
        if (typeof ymaps == 'undefined') {
            // Необходим api key для геокодера
            $.getScript('https://api-maps.yandex.ru/2.1/?apikey=607007ed-0904-4368-8445-809187c8313d&load=package.standard&lang=ru-RU', function() {
                if (typeof ymaps !== 'undefined') {
                    shmMap.initYandexMap();
                }
            });
        } else {
            shmMap.initYandexMap();
        }
        shmMap.bindEvents();
    },
    initYandexMap: function() {
        ymaps.ready(function() {
            window.yaMap = new ymaps.Map('map', {
                center: [shmMap.config.mapLat, shmMap.config.mapLon],
                controls: [],
                zoom: 9,
            });

            const zoomControl = new ymaps.control.ZoomControl({
                options: {
                    position: {
                        top: 10,
                        left: 10,
                    },
                },
            });
            window.yaMap.controls.add(zoomControl);

            const fullscreenControl = new ymaps.control.Button({
                data: {
                    image: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiI+PGcgZmlsbD0iIzZCNkI2QiI+PHBhdGggZD0iTTE2LjE0IDcuODZMMTQuMjcgNkgyMHY1LjdsLTEuODMtMS44MkwxNS4wNCAxMyAxMyAxMC45OGwzLjEzLTMuMTN6bTAgME05Ljg2IDE4LjE0TDExLjczIDIwSDZ2LTUuN2wxLjgzIDEuODJMMTAuOTYgMTMgMTMgMTUuMDJsLTMuMTMgMy4xM3ptMCAwIi8+PC9nPjwvc3ZnPg==',
                    title: 'Развернуть карту',
                },
                options: {
                    selectOnClick: false,
                },
            });
            window.yaMap.controls.add(fullscreenControl, {float: 'right'});

            fullscreenControl.events.add('click', function(event) {
                toggleMap();
            });


            window.objectManager = new ymaps.ObjectManager({
                clusterize: false,
            });

            jQuery.getJSON('/shinomontazh/points/', function(json) {
                window.objectManager.add(json);
                yaMap.geoObjects.add(window.objectManager);
            });

            navigator.geolocation.getCurrentPosition(onSuccess, onError, {timeout: 30000});

            function sortAddress(coords) {
                $('.search-block input[name=from]').val(coords[0] + ',' + coords[1]);

                // blockSort.setSort(['distance', true]);
                // blockSort.trigger('sort:change');
            };

            function onSuccess(position) {
                const lat = position.coords.latitude;
                const lng = position.coords.longitude;

                // yaMap.setCenter([lat, lng], 15, {
                //     checkZoomRange: true
                // });

                // console.log(lat, lng);

                sortAddress([lat, lng]);
            }

            function onError(error) {
                console.log('error getting location:' + error.message);
            }

            shmMap.bindEventsItem();

            $(shmMap.config.mapToggle).on('click', function (event) {
                event.preventDefault();
                toggleMap();
            });

            function toggleMap() {
                shmMap.config.mapBig = !shmMap.config.mapBig;

                if (shmMap.config.mapBig) {
                    $('.search-map--big').addClass('search-map--open');
                } else {
                    $('.search-map--big').removeClass('search-map--open');
                }

                window.yaMap.container.fitToViewport();
            }
        });
    },
    evaluateCallbackMap: function(response) {
        if (window.objectManager) {
            window.objectManager.removeAll();
            window.objectManager.add(response.data);
        }
    },
    set_map_focus: function(map_id, map_id_old) {
        window.objectManager.objects.setObjectOptions(map_id_old, {
            iconColor: '#38a93a',
        });
        window.objectManager.objects.setObjectOptions(map_id, {
            iconColor: '#E100FF',
        });
    },
    set_map_zoom: function(zoom) {
        window.yaMap.setZoom(zoom);
    },
    set_map_center: function(lat, lon) {
        window.yaMap.setCenter([lat, lon]);
    },
    set_search_marker: function() {
        document.cookie = `smt_search_marker=${window.location}; max-age=86400; path=/; domain=.4tochki.ru;`;
        return true;
    },
};
